<template>
    <b-card class="mt-4" :header-html="`
        <h4><i class='glyphicon glyphicon-user'></i> Dados de acesso</h4>
    `">
        <b-row>
            <b-col md="6">
                <b-form-group 
                    label="E-mail" label-for="email" class="required">
                    <b-form-input
                        id="email"
                        name="email"
                        maxlength="60"
                        v-model="data.Usuario.email"
                        v-validate="'required|email'"
                        :class="[{ error: errors.first('email') }]"
                    />
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group 
                    label="Senha" label-for="senha" class="required">
                    <b-form-input
                        id="senha"
                        name="senha"
                        type="password"
                        
                        v-model="data.Usuario.senha"
                        v-validate="'required'"
                        :class="[{ error: errors.first('senha') }]"
                    />
                </b-form-group>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
export default {
    inject: ['$validator'],
    props: {
        data: {
            default: {}
        }
    }
}
</script>